import { usePhotoPlacementOptional } from '@/contexts/photo-placement-context'
import {
  type UsePlacementCanvasBridgeArgs,
  usePlacementCanvasBridge,
} from '@/hooks/use-placement-canvas-bridge'
import { isPhotoDropBlockedByTextChain } from '@/lib/photos/linked-text-photo-drop-policy'

type PhotoPlacementCanvasBridgeProps = Omit<
  UsePlacementCanvasBridgeArgs,
  'placement' | 'isBlockedByTextChain'
>

/**
 * Registers the canvas's geometry and drop-target hit test with the photo placement provider. The
 * logic is shared with ClikArt — see `usePlacementCanvasBridge`.
 */
export function PhotoPlacementCanvasBridge(props: PhotoPlacementCanvasBridgeProps) {
  usePlacementCanvasBridge({
    ...props,
    placement: usePhotoPlacementOptional(),
    isBlockedByTextChain: isPhotoDropBlockedByTextChain,
  })

  return null
}
